import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

export class LinksSlider {
	constructor(el) {
		this.el = el;
		this.slider = null;
		this.init();
	}

	init() {
		this.slider = new Swiper(this.el, {
			slidesPerView: 'auto',
			spaceBetween: 20,
			modules: [FreeMode],
			freeMode: true,
		});
	}
}
